<template>
  <div
    class="form-checkbox-wrapper d-flex align-items-center"
    @click="toggle()"
  >
    <div class="checkbox">
      <font-awesome-icon icon="check" v-if="value" />
    </div>
    <span>{{ schema.name }}</span>
  </div>
</template>

<script>
import { abstractField } from "vue-form-generator";

export default {
  name: "FormCheckbox",
  mixins: [abstractField],
  methods: {
    toggle() {
      this.value = !this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox-wrapper {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  .checkbox {
    $size: 16px;
    width: $size;
    height: $size;
    line-height: $size;
    text-align: center;
    border: 1px solid #999;
    font-size: 10px;
    border-radius: 5px;
    color: #249bd2;
    cursor: pointer;
    display: inline-block;
    margin-right: 7px;
  }

  span {
    font-size: 12px;
    color: #8f8f8f;
  }
}
</style>
